module.exports = __webpack_public_path__ + "static/img/05@2x.50a27ee7.png";